export default function getResource(label) {
    const resources = {
        compareProducts: 'Compare Products',
        emptySlot: 'Empty',
        unableToCompareProductsTitle: 'Unable To Compare Products',
        unableToCompareProductsMessage: 'Something went wrong. Please try again in a moment.',
        gotIt: 'Got It',
        colors: 'Colors',
        color: 'Color',
        sizes: 'Sizes',
        size: 'size',
        standardSize: 'Standard size: ',
        ratingsAndReviews: 'Rating & Reviews',
        prosMentioned: 'Pros Mentioned',
        consMentioned: 'Cons Mentioned',
        overview: 'Overview',
        ingredients: 'Ingredients',
        pickupAndDelivery: 'Pickup & Delivery',
        showAll: 'Show all',
        showLess: 'Show less',
        bopis: 'Buy Online & Pickup at ',
        gis: 'Get It Shipped: ',
        sdd: 'Same Day Delivery: ',
        setLocation: 'Set Location',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        goodFor: 'Good For',
        targetedConcerns: 'Targets Concerns',
        benefits: 'Benefits'
    };

    return resources[label];
}
